var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "#FDF5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17676 4.70383C9.42668 4.57034 9.71076 4.5 10 4.5C10.2893 4.5 10.5733 4.57034 10.8233 4.70383C11.0729 4.83716 11.2795 5.02872 11.4221 5.25902L15.7809 12.2515C15.924 12.4791 15.9999 12.738 16 13.0006C16.0001 13.2636 15.9247 13.522 15.7813 13.7498C15.638 13.9776 15.4318 14.1669 15.1835 14.2986C14.9352 14.4302 14.6534 14.4997 14.3665 14.5H5.64722C5.35986 14.5019 5.077 14.4344 4.82715 14.3042C4.57652 14.1736 4.36801 13.9846 4.22275 13.7563C4.07749 13.5281 4.00064 13.2686 4 13.0044C3.99937 12.7405 4.07472 12.4812 4.21844 12.2526L4.21911 12.2515L8.57741 5.25989C8.72001 5.0296 8.92716 4.83716 9.17676 4.70383ZM10 5.4993C9.9036 5.4993 9.8089 5.52275 9.7256 5.56725C9.64229 5.61174 9.57335 5.6757 9.52581 5.7526L9.52485 5.75414L5.16316 12.7512C5.11511 12.8275 5.08991 12.9141 5.09012 13.0022C5.09033 13.0902 5.11595 13.1767 5.16437 13.2528C5.21279 13.3289 5.28229 13.3919 5.36584 13.4354C5.44938 13.479 5.54399 13.5015 5.64008 13.5007L5.64499 13.5006L14.3654 13.5007C14.461 13.5006 14.5549 13.4774 14.6377 13.4335C14.7205 13.3896 14.7892 13.3266 14.837 13.2506C14.8848 13.1747 14.9099 13.0885 14.9099 13.0009C14.9099 12.9132 14.8847 12.8271 14.8369 12.7512L14.8356 12.7493L10.4752 5.75414L10.4742 5.7526C10.4267 5.6757 10.3577 5.61174 10.2744 5.56725C10.1911 5.52275 10.0964 5.4993 10 5.4993Z",
    fill: "#925E07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 7.46298C10.3207 7.46298 10.5806 7.71171 10.5806 8.01854V10.2408C10.5806 10.5476 10.3207 10.7963 9.99999 10.7963C9.67931 10.7963 9.41935 10.5476 9.41935 10.2408V8.01854C9.41935 7.71171 9.67931 7.46298 9.99999 7.46298Z",
    fill: "#925E07"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41935 12.0926C9.41935 11.7858 9.67802 11.537 9.99711 11.537H10.0029C10.322 11.537 10.5806 11.7858 10.5806 12.0926C10.5806 12.3994 10.322 12.6481 10.0029 12.6481H9.99711C9.67802 12.6481 9.41935 12.3994 9.41935 12.0926Z",
    fill: "#925E07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingWarning);
export default __webpack_public_path__ + "static/media/pendingWarning.3fbb3006617d09f6831b6ef24a8b305f.svg";
export { ForwardRef as ReactComponent };